// extracted by mini-css-extract-plugin
module.exports = {"breadCrum":"breadcrum_breadCrum__3GiZ2"};